module.exports = __webpack_public_path__ + "img/icon_product_1.6ee0701f.svg";